import { z } from 'zod'

export const NotifyAction = z.object({
  label: z.string(),
  route: z.string().optional()
})

export const Notify = z.object({
  id: z.string().uuid(),
  alertType: z.enum(['success', 'info', 'warning', 'error']),
  title: z.string(),
  message: z.string(),
  action: NotifyAction.optional()
})

export type NotifyAction = z.infer<typeof NotifyAction>
export type Notify = z.infer<typeof Notify>
